// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {DecoratorStyle} from './decorator-style.js'

export class SetDecoratorStyle {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetDecoratorStyle {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetDecoratorStyle(bb: flatbuffers.ByteBuffer, obj?: SetDecoratorStyle): SetDecoratorStyle {
    return (obj || new SetDecoratorStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetDecoratorStyle(
    bb: flatbuffers.ByteBuffer,
    obj?: SetDecoratorStyle
  ): SetDecoratorStyle {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetDecoratorStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(): DecoratorStyle | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startSetDecoratorStyle(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, value: DecoratorStyle) {
    builder.addFieldInt8(0, value, null)
  }

  static endSetDecoratorStyle(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetDecoratorStyle(builder: flatbuffers.Builder, value: DecoratorStyle | null): flatbuffers.Offset {
    SetDecoratorStyle.startSetDecoratorStyle(builder)
    if (value !== null) SetDecoratorStyle.addValue(builder, value)
    return SetDecoratorStyle.endSetDecoratorStyle(builder)
  }
}
